/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Or_Sign_Up_WithInputs */

const en_mobile_or_sign_up_with = /** @type {(inputs: Mobile_Or_Sign_Up_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or sign up with`)
};

const es_mobile_or_sign_up_with = /** @type {(inputs: Mobile_Or_Sign_Up_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O regístrate con`)
};

/**
* | output |
* | --- |
* | "Or sign up with" |
*
* @param {Mobile_Or_Sign_Up_WithInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_or_sign_up_with = /** @type {((inputs?: Mobile_Or_Sign_Up_WithInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Or_Sign_Up_WithInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_or_sign_up_with(inputs)
	return en_mobile_or_sign_up_with(inputs)
});